import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c982e50"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "vue-tl-card-chooser-component"
}
const _hoisted_2 = {
  key: 0,
  class: "card-chooser"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Choose a card", -1 /* HOISTED */))
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add new card", -1 /* HOISTED */))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Add your card", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardComponent = _resolveComponent("CardComponent")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasValidCard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.cardChooser.choosingDifferentCard || _ctx.alwaysShow)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: card.Id,
                      class: _normalizeClass(["card", { 'current': card.Id === _ctx.selectedCard.Id }])
                    }, [
                      _createElementVNode("span", {
                        class: "card-number",
                        title: `expiry: ${card.Expiry}`,
                        onClick: ($event: any) => (_ctx.setActiveCard(card))
                      }, _toDisplayString(card.Brand) + ": **** **** **** " + _toDisplayString(card.Last4), 9 /* TEXT, PROPS */, _hoisted_4),
                      (_ctx.cards.length > 1)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "card-delete",
                            title: "Delete card",
                            onClick: ($event: any) => (_ctx.deleteCardChoice(card))
                          }, "×", 8 /* PROPS */, _hoisted_5))
                        : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _createElementVNode("li", {
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openModalToAddCard && _ctx.openModalToAddCard(...args)), ["prevent"]))
                  }, _hoisted_7)
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.cardChooser.modalOpen)
      ? (_openBlock(), _createBlock(_component_ModalComponent, {
          key: 1,
          buttons: _ctx.modalButtons,
          loading: _ctx.loading,
          onClose: _ctx.closeModalToAddCard
        }, {
          header: _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx(() => [
            _createVNode(_component_CardComponent, {
              ref: "card",
              class: "cb-card fieldset field",
              currency: 'AUD',
              fonts: _ctx.cbCard.fonts,
              styles: _ctx.cbCard.styles,
              placeholder: _ctx.cbCard.placeholder,
              locale: _ctx.cbCard.locale,
              onChange: _ctx.cbCardChanged
            }, null, 8 /* PROPS */, ["fonts", "styles", "placeholder", "locale", "onChange"])
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["buttons", "loading", "onClose"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}